import { render, staticRenderFns } from "./DepartmentLinks.vue?vue&type=template&id=4eb8ca9e&scoped=true"
import script from "./DepartmentLinks.vue?vue&type=script&lang=js"
export * from "./DepartmentLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb8ca9e",
  null
  
)

export default component.exports